var MDB = window.MDB || {};;
MDB.Forms = MDB.Forms || {};
MDB.Forms.Index = MDB.Forms.Index || {};

(function() {
    var _answersId,
        _boot = true,
        _changesMade = true,
        _completeHtml = '<i class="fa fa-save"></i> ' + MDB.loadResourceString('Dpo_Intake_Index_Save_Button_Complete_DisplayName'),
        _config,
        _currentAnswers = [],
        _currentPage = 0,
        _files = 'files:',
        _guidEmpty = '00000000-0000-0000-0000-000000000000',
        _image = 'image:',
        _intakeBackBtn,
        _intakeForwardBtn,
        _intakeValidateBtn,
        _intakeSaveBtn,
        _invalidInputs = [],
        _kvkData = [
            {'system': 'companyname', 'kvk': 'handelsnaam', 'local': 'Name'},
            {'system': 'companystreet', 'kvk': 'straat', 'local': 'Street'},
            {'system': 'companyzipcode', 'kvk': 'postcode', 'local': 'Zipcode'},
            {'system': 'companyhouseno', 'kvk': 'huisnummer', 'local': 'HouseNo'},
            {'system': 'companyhousenoadd', 'kvk': 'huisnummertoevoeging', 'local': 'HouseNoAdd'},
            {'system': 'companycity', 'kvk': 'plaats', 'local': 'City'},
            {'system': 'companycountry', 'kvk': 'land', 'local': 'Country'},
            {'system': 'companylegal', 'kvk': 'rechtsvorm', 'local': 'LegalForm'},
            { 'system': 'companykvk', 'kvk': 'dossiernummer', 'local': 'Kvk' }
        ],
        _legalForms = ['b.v.', 'v.o.f.', 'vof', 'bv', 'nv', 'n.v.', 'cv', 'c.v.',],
        _moreOptions = 'more-options',
        _nrOfPages = 0,
        _popup,
        _redirectUrl = '/DPO/Dashboard/',
        _saveIntermediateHtml = '<i class="fa fa-save"></i> ' + MDB.loadResourceString('Dpo_Intake_Index_Save_Button_Incomplete_DisplayName'),
        _saveHtml = '<i class="fa fa-save"></i> ' + MDB.loadResourceString('Dpo_Intake_Index_Save_Button_Save_DisplayName'),
        _triggers = [];

    $.extend(MDB.Forms.Index,
        {
            boot: function (config) {
                var answers = $('#answers-id');
                _answersId = answers.val() != _guidEmpty  ? answers.val() : MDB.Forms.Index.Guid(),
                _config = config,
                _intakeForwardBtn = $('#intake-forward-btn'),
                _intakeBackBtn = $('#intake-back-btn'),
                _intakeValidateBtn = $('#intake-validate-btn'),
                _intakeSaveBtn = $('#intake-save-btn'),
                _popup = $('#popup');

                //Prevent propagation to not let the event bubble up to a potential parent modal
                _popup.on('hide.bs.modal', function (e) {
                    e.stopPropagation(); 
                });

                _popup.on('click', '.popup-close', function(e) {
                    MDB.Forms.Index.hidePopup();
                });

                //Reset popup when hidden.
                _popup.on('hidden.bs.modal', function (e) {
                    e.stopPropagation();

                    MDB.Forms.Index.hidePopup();
                    MDB.Forms.Index.checkOpenModals();
                });

                //            MDB.Forms.Index.initControls();

                //Set number of pages.
                _nrOfPages = MDB.Forms.Index.getTotalPages();

                //get page from url
                var page = parseInt(window.location.hash.substring(1), 10);
                if (isNaN(page)){
                    page = 0;
                    window.location.hash = 0;
                }

                //load triggers before we load the answers.
                MDB.Forms.Index.initTriggers();

                MDB.Forms.Index.initNotApplicableCheckboxes();

                //load existing answers into form if any and set the current page.
                MDB.Forms.Index.loadAnswers();


                //            console.log('start multiple choice...');
                //            var t0 = performance.now();
                var questionGroups = $('.question-group');
                MDB.Forms.Index.initMultipleChoice(questionGroups);
                //            var t1 = performance.now();
                //            console.log('done multiple choice in ' + (t1 - t0) / 1000 + ' seconds.');

                //            console.log('start init buttons...');
                //            t0 = performance.now();
                MDB.Forms.Index.initButtons(questionGroups);
                //            t1 = performance.now();
                //            console.log('done init buttons in ' + (t1 - t0) / 1000 + ' seconds.');

                //            console.log('init not applicable...');
                //            t0 = performance.now();
                MDB.Forms.Index.initNotApplicableCheckboxes();
                //             t1 = performance.now();
                //            console.log('done not applicable in ' + (t1 - t0) / 1000 + ' seconds.');

                //            console.log('start init controls...');
                //            t0 = performance.now();
                MDB.Forms.Index.initControls();
                //             t1 = performance.now();
                //            console.log('done init controls in ' + (t1 - t0) / 1000 + ' seconds.');

                MDB.Forms.Index.initPopovers();

                //reload page completed status and validate input when questions lose focus.
                MDB.Forms.Index.initFormAnswerChanged($('.question'));

                //Take all answerIds with 'NotApplicable' -> set to true, click the NotApplicable checkboxes
                _config.answers.forEach(function(group) {
                    var context = group.groupingid ? $('[data-grouping-id="' + group.groupingid + '"]') : $(document);

                    _.filter(group.answers, 'notapplicable').forEach(function (answer) {
                        context.find('[data-id="' + answer.id + '"] [name="not-applicable-chk"][data-target="question"]').click();
                    });
                });

                //Hide 'cloned' pages
                _.values(_.groupBy($('.question-group.can-multiply'), 'dataset.id')).forEach(function(group) {
                    _.takeRight(group, group.length - 1).forEach(function (item) {
                        $(item).hide();
                    });
                });

                MDB.Forms.Index.doTextReplaces();

                MDB.Forms.Index.initControlShortcuts();

                //set button states based on page completion and page number.
                MDB.Forms.Index.setButtonsState();

                MDB.Forms.Index.setCurrentPage(page, true);

                //handle back and forward browser events
                window.addEventListener("popstate", function (e) {
                    var page = parseInt(document.location.hash.substring(1), 10);
                    MDB.Forms.Index.setCurrentPage(page, true);
                });
            },
            initPopovers: function(context) {
                MDB.initPopovers(context);
            
                //context = context == null ? $('body') : context;

            // context.find('[data-toggle="popover"]').popover({
            //     html: true,
            //     container: 'body',
            //     placement: 'right',
            //     content: function () {
            //         return $('#popover-content').html();
            //     }
            // });
            },
            initFormAnswerChanged: function (question) {
                question.filter('textarea').on('blur', function(){
                    var me = $(this);
                
                    MDB.Forms.Index.checkTriggers(me);
                    MDB.Forms.Index.formAnswersChanged(me);
                }).each(function(){
                    MDB.Forms.Index.checkTriggers($(this));
                });
            
                question.filter(':not(textarea,.multiple)').on('blur', function () {
                    MDB.Forms.Index.formAnswersChanged($(this)); 
                });
            },
            formAnswersChanged: function (question) {
                MDB.Forms.Index.validateInput(question);
                MDB.Forms.Index.setButtonsState();
                MDB.Forms.Index.doTextReplaces();
                _changesMade = true;
            },
            deleteGroupGeneratedAnswerSources: function (group) {
                group.find('[data-answer-source]').each(function() {
                    var optionIdentifier = $(this).closest('[data-id]').prop('id');
                    $('option[data-option-identifier="' + optionIdentifier + '"]').remove();
                });
            },
            initAnswerSources: function (context) {
                var callbacksPerQuestion = {};

                var invokeCallback = function (question) {
                    var questionId = question
                        .closest('.question-container')
                        .find('[name="question-id"]')
                        .val();
                
                    if (callbacksPerQuestion[questionId]) {
                        callbacksPerQuestion[questionId].forEach(function (callback) {
                            callback();
                        });
                    }
                };

                context.find('.question-container[data-answer-source]').each(function () {
                    var container = $(this);

                    var question = container.find('[name="question-id"]')
                        , questionId = question.val()
                        , questionRow = container.closest('[data-id="' + questionId + '"]')
                        , optionIdentifier = questionRow.prop('id');

                    var questionCallbacks = [];
                    if (!callbacksPerQuestion[questionId]) {
                        callbacksPerQuestion[questionId] = questionCallbacks;
                    }

                    questionCallbacks = callbacksPerQuestion[questionId];

                    container.data('answer-source').forEach(function (answerSource) {
                        var isMatch = !answerSource.conditions
                            , valueSelector = container.closest('.question-group').find(answerSource.valueselector);

                        var answerChanged = function () {
                            if (answerSource.conditions) {
                                answerSource.conditions.forEach(function(condition) {
                                    if (condition.or) {
                                        isMatch = container.find('[name="answer"][value="' + condition.or.value + '"]').next().is(':checked');
                                    }
                                });
                            }
                        
                            var targetQuestions = $('[data-id="' + answerSource.for + '"] select.question');
                            var currentOptions = targetQuestions.find('option[data-option-identifier="' + optionIdentifier + '"]');
                        
                            if (!isMatch || !container.hasClass('active')) {
                                currentOptions.remove();
                                return;
                            }

                            //TODO: Option for global valueSelector scope, filter out inactive questions
                            var value = valueSelector.val();

                            targetQuestions
                                .filter(':not(:has(option[data-option-identifier="' + optionIdentifier + '"]))')
                                .append($('<option />').attr('data-option-identifier', optionIdentifier));

                            //In case more have been added
                            currentOptions = targetQuestions.find('option[data-option-identifier="' + optionIdentifier + '"]');

                            currentOptions.text(value);
                            currentOptions.val(value);

                            if (_config.answers) {
                                targetQuestions.each(function () {
                                    var select = $(this);

                                    var group = select.closest('.question-group').attr('data-grouping-id');
                                    var answerGroup = _.find(_config.answers, { groupingid: group });

                                    if (answerGroup) {
                                        var id = select.siblings('[name="question-id"]').val();
                                        var answer = _.find(answerGroup.answers, { id: id });

                                        if (answer != null) {
                                            var selector = '#' + select.prop('id') + ' option[value="' + answer.answer + '"]';
                                            $(selector).prop('selected', true);
                                        }
                                    }
                                });
                            }
                        };

                        valueSelector.on('blur', function() {
                            invokeCallback(question);
                        });

                        questionCallbacks.push(answerChanged);
                    });
                });

                return invokeCallback;
            },
            initControlShortcuts: function () {
            //bind arrowkeys to forward and back for easy navigation
                $(document).keydown(function (e) {
                    var active = $(document.activeElement);

                    //If page up or down are pressed switch page.
                    if (e.keyCode == 34) {
                        e.preventDefault();
                        if(!_intakeBackBtn.hasClass('disabled')) {
                            _intakeBackBtn.click();
                        }
                    } else if (e.keyCode == 33) {
                        e.preventDefault();
                        if(!_intakeForwardBtn.hasClass('disabled')) {
                            _intakeForwardBtn.click();
                        }
                    }

                    //Else only navigate on arrow keys if no inputs (or textarea's - sigh - ) are selected.
                    if(e.keyCode == 37) {
                        if(!_intakeBackBtn.hasClass('disabled') && !active.is('input') && !active.is('textarea')) {
                            _intakeBackBtn.click();
                        }
                    } else if (e.keyCode == 39) {
                        if(!_intakeForwardBtn.hasClass('disabled') && !active.is('input') && !active.is('textarea')) {
                            _intakeForwardBtn.click();
                        }
                    } 

                    //Save form when ctrl+s is pressed
                    else if ((e.ctrlKey || e.metaKey) && e.which == 83) {
                        if (_intakeSaveBtn.is(':visible')) {
                            MDB.Forms.Index.saveForm();
                            e.preventDefault();
                        }
                    } 
                });
            },
            initTriggers: function() {
                $('[name="question-trigger"]').each(function () {
                    var questionId = this.dataset.questionId;
                    var parts = this.value.split('|');

                    if (parts[0].indexOf(',') !== -1) {
                        var keys = parts[0].split(',');
                        var questions = parts[1].split(',');
                        var conditions = parts[2].split(',');
                        var popuptitles = parts[3].split('!.!');
                        var popupbodies = parts[4].split('!.!');
                        var popupbuttons = parts[5].split(',');
                        var popupsizes = parts[6].split(',');
                        var triggerAllOptions = parts[7] === 'True';

                        var getIndexed = function (arr, idx) {
                            if (triggerAllOptions && idx !== 0) {
                                return getIndexed(arr, 0);
                            }

                            return idx < arr.length ? arr[idx] : '';
                        };

                        keys.forEach(function (key, i) {
                            _triggers.push({
                                question: questionId,
                                key: key,
                                triggers: getIndexed(questions, i),
                                condition: getIndexed(conditions, i),
                                popuptitle: getIndexed(popuptitles, i),
                                popupbody: getIndexed(popupbodies, i),
                                popupbutton: getIndexed(popupbuttons, i),
                                popupsize: getIndexed(popupsizes, i)
                            });
                        });
                    } else {
                        _triggers.push({
                            question: questionId,
                            key: parts[0],
                            triggers: parts[1],
                            condition: parts[2],
                            popuptitle: parts[3],
                            popupbody: parts[4],
                            popupbutton: parts[5],
                            popupsize: parts[6]
                        });
                    }  
                });
            },
            scrollToFirstInvalidInput: function (page) {
                var currentPage = _.isNumber(page) ? page : MDB.Forms.Index.getCurrentPage();

                var input = _.find(_invalidInputs, { page: currentPage });

                var inputElement = !input ? undefined : document.getElementById(input.inputId);
                if (!inputElement) {
                    return;
                }

                var elementSelector = $(inputElement);

                var invalidInputGroup = elementSelector.closest('.question-group');
                if (invalidInputGroup.is('.can-multiply')) {
                    invalidInputGroup.siblings('.can-multiply[data-id="' + invalidInputGroup.data('id') + '"]').hide();
                    invalidInputGroup.show();
                }

                inputElement.scrollIntoView({ block: 'end' });
            },
            initControls: function() {
                _intakeForwardBtn.unbind('click');
                _intakeForwardBtn.click(function () {
                    if ($(this).hasClass('disabled')) {
                    //Actually display the errors
                        MDB.Forms.Index.validatePage(_currentPage);
                        MDB.Forms.Index.scrollToFirstInvalidInput(_currentPage);
                    } else {
                        MDB.Forms.Index.setCurrentPage(_currentPage + 1);
                    }
                });

                _intakeBackBtn.unbind('click');
                _intakeBackBtn.click(function () {
                    if (!$(this).hasClass('disabled')) {
                        MDB.Forms.Index.setCurrentPage(_currentPage - 1);
                    }
                });

                _intakeValidateBtn.unbind('click');
                _intakeValidateBtn.click(function() {
                //Actually display the errors
                    MDB.Forms.Index.validatePage(_currentPage);
                    MDB.Forms.Index.scrollToFirstInvalidInput(_currentPage);
                });

                _intakeSaveBtn.unbind('click');
                _intakeSaveBtn.click(function () {

                    // if ($(this).hasClass('disabled')) {
                    //Actually display the errors
                    MDB.Forms.Index.validatePage(_currentPage);
                    MDB.Forms.Index.scrollToFirstInvalidInput(_currentPage);
                    // }

                    //Always save
                    MDB.Forms.Index.saveForm();
                });

                MDB.Forms.Index.initFileUploads();

                MDB.Forms.Index.initMultiplyButtons();
                MDB.Forms.Index.prependKvKSearchToCompanyInputs();
                MDB.Forms.Index.setCompanySearchButtons();
            },
            doTextReplaces: function () {
                $('[name="question-label"]').each(function () {
                    var me = $(this);
                    MDB.Forms.Index.replaceTexts(me);
                });

                $('[name="question-group-label"]').each(function () {
                    var me = $(this);
                    MDB.Forms.Index.replaceTexts(me);
                });
            },
            replaceTexts: function (selector) {
                var regex = /[[][0-9A-Fa-f]{8}[-]?(?:[0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}]/ig;
                var moreMatches = true;
                var template = selector.prev().val();
                
                while(moreMatches) {
                    match = regex.exec(template);
                    
                    if(match != null) {
                        var id = match[0].substring(1,37);
                        
                        var text = MDB.Forms.Index.getAnswers(id);

                        selector.html(template.replace(match[0], text));
                    } else {
                        moreMatches = false;
                    }
                }
            },
            initFileUploads: function() {
                $('.file-upload').each(function() {
                    var me = $(this);

                    me.kendoUpload({
                        async: {
                            saveUrl: me.prop('name') === 'image' ? _config.saveImageUrl : _config.saveFileUrl,
                            removeUrl: _config.removeUrl,
                            batch: me.prop('name') === 'image' ? false : true
                        },
                        success: function (e) {
                            me = me.is('[id^="q"]') ? me : me.siblings('[id^="q"]:first');

                            if (e.response.errors && e.response.errors.length > 0) {
                                MDB.Notify.bootstrapDanger(e.response.errors.join(', '));
                            } else {
                                if(me.prop('name') === 'image') {
                                
                                    me.parents('.upload-container').find('#image-preview')
                                        .html('<img src="'+ _config.imagePreviewUrl  +'?filename='+
                                        encodeURIComponent(e.response.data) + '" class="preview-image" />');

                                    me.text(e.response.data);
                                } else if (me.prop('name') === 'files') {

                                    // get existing files amd
                                    var responseFiles = e.response.data.split(',');
                                    var existingFiles = me.text() !== '' ? me.text().split(':')[1].split(',') : [];


                                    //Add files that are new. Do nothing for overwritten files
                                    responseFiles.forEach(function (file) {
                                        if(!_.includes(existingFiles, file)) {
                                            existingFiles.push(file)
                                        }
                                    });
                                
                                    me.text(_files + existingFiles.join(','));

                                    //reload the files partial.
                                    me.parents('.upload-container').find('.files-uploaded').load(_config.previewFilesUrl + 
                                    '?filenames=' + encodeURIComponent(me.text().split(':')[1]) + '', function() {
                                        MDB.Forms.Index.loadFileDeleteButtons();
                                    });
                                }

                                //Save intake quietly, as it is counter intuitive to upload a picture and it being gone after a refresh.
                                MDB.Forms.Index.saveForm(true);

                                e._isFileUpload = true;
                                MDB.Forms.Index.checkTriggers(me, e);
                                MDB.Forms.Index.formAnswersChanged(me);
                            }
                        },
                        upload: function (e) {
                            if(me.prop('name') === 'files'){
                                e.data = {
                                    questionId: me.parents().closest('.question-container').find('[name="question-id"]').val()
                                };
                            }
                        },
                        error: function () {
                            MDB.Notify.bootstrapDanger('Something went wrong.');
                        }
                    });

                    //Set up custom dropzone. Don't look on entire page, there might be more than one.
                    var dropzone = me.closest('td').find('.drop-area');
                    dropzone.on('dragenter', handleDragEnter);
                    dropzone.on('dragover', handleDragOver);
                    dropzone.on('dragleave', handleDragLeave);
                    dropzone.on('drop', handleDrop);
                    dropzone.on('mouseleave', handleDragLeave);
                    dropzone.on('click', handleClick);

                    function handleClick(e) {
                        var me = $(dropzone);
                        me.prev().find('[type="file"]').each(function(){
                            var input = $(this);

                            if(input.prop('id').match('^q')) {
                                input.show();
                                input.click();
                            }
                        });
                    }

                    function handleDragEnter(e) {
                        dropzone.addClass('hover');
                        dropzone.find('span').addClass('hover');
                    }

                    function handleDragOver(e) {
                        e.stopPropagation();
                        e.preventDefault();
                        e.originalEvent.dataTransfer.dropEffect = 'move';
                    }

                    function handleDragLeave(e) {
                        dropzone.removeClass('hover');
                        dropzone.find('span').removeClass('hover');
                    }

                    function handleDrop(e) {
                        e.stopPropagation();
                        e.preventDefault();

                        var event = jQuery.Event("drop");
                        event.originalEvent = e.originalEvent;
                        $(this).parent().find('.file-upload').trigger(event);
                    }
                    me.closest('div.k-widget.k-upload.k-header.k-upload-empty').hide();
                });
            },
            initButtons: function(context) {
                context.find('button.question').on('click', function(e) {
                    MDB.Forms.Index.checkPopupTriggers($(this), e);
                });
            },
            initMultipleChoice: function (context) {
                var container = context.find('.multiple-choice')
                    , radioButton = container.find('.radio-option')
                    , checkBox = container.find('.check-option');

                radioButton.unbind('click');
                checkBox.unbind('click');

                var answerSourceCallback = MDB.Forms.Index.initAnswerSources(context);

                radioButton.on('click', function (e) {
                    var me = $(this)
                        , row = me.closest('.multiple-choice');

                    MDB.Forms.Index.checkTriggers(me, e);

                    row.find('.radio-option').removeClass('serialize');
                    me.addClass('serialize');

                    MDB.Forms.Index.initUniqueAnswers(me);

                    answerSourceCallback(me);
                    MDB.Forms.Index.formAnswersChanged(me);
                });

                checkBox.on('click', function (e) {
                    var me = $(this);
                    MDB.Forms.Index.checkTriggers(me, e);
                    answerSourceCallback(me);
                    MDB.Forms.Index.checkOptionClick(me);
                });

                var moreOptions = checkBox.prev().filter('[value="' + _moreOptions + '"]');
                MDB.Forms.Index.initExtraChoiceOptions(moreOptions);

                container.find('.radio-option:checked,.check-option:checked')
                    .addClass('serialize');

                container.filter(':has(.serialize)').each(function() {
                    var opt = $(this).find('.serialize:first');
                    MDB.Forms.Index.checkTriggers(opt);
                    answerSourceCallback(opt);
                    MDB.Forms.Index.formAnswersChanged(opt);
                });
                MDB.Forms.Index.triggerUniques();
                MDB.Forms.Index.checkIfOnlyOneOption(radioButton);
            },
            checkIfOnlyOneOption: function (radioOptions) {
                radioOptions.each(function () {
                    var me = $(this);
                    if(me.hasClass('required') && me.parents('.multiple-choice').children().find('.radio-option').length == 1) {
                        me.click();
                        me.click();
                        me.prop('disabled', true);
                    }
                });
            },
            initUniqueAnswers: function(question) {
                if (question.data('unique') === true) {
                    MDB.Forms.Index.disableUniqueOptions(question);
                } else {
                    var uniqueAnswers = question.parents('.multiple-choice').find('.multiple[data-unique="true"]');

                    if(uniqueAnswers.length > 0) {
                        uniqueAnswers.each(function(){
                            MDB.Forms.Index.enableUniqueOptions($(this));
                        });
                    }
                }
            },
            disableUniqueOptions: function (selector) {
                $('.radio-option[data-question-id="'+ selector.attr('data-question-id') +'"]:not(:checked)').each(function() {
                    var me = $(this);

                    if(me.next().text() == selector.next().text()) {
                        me.prop('checked', false);
                        me.removeClass('serialize');
                        me.prop('disabled', true);
                    }
                });
                selector.prop('checked', true);
                selector.addClass('serialize');
            },
            enableUniqueOptions: function (selector) {
                var selectedUniques = $('.radio-option[data-question-id="' + selector.attr('data-question-id') + '"][data-unique="true"]:checked');

                if(selectedUniques.length == 0) {
                    var options = $('.radio-option[data-question-id="'+ selector.attr('data-question-id') +'"]');

                    options.each(function() {
                        var me = $(this);
                        if(me.next().text() == selector.next().text()) {
                            me.prop('disabled', false);
                        }
                    });
                }
            },
            triggerUniques: function () {
                var uniques = $('.radio-option[data-unique="true"]:checked');
                uniques.click();
            },
            //Used in popups
            wirePopupRadioButtons: function(name, targetQuestionId){
                var targetQuestion = $('input[name="question-id"][value="' + targetQuestionId + '"]')
                    .closest('.question-container')
                    .find('.question');

                var targetButtons = _popup.find('input[type="radio"][name="' + name + '"]');
                var currentAnswer = targetQuestion.val();

                if(currentAnswer){
                    targetButtons.filter('[value="' + currentAnswer + '"]').trigger('click');
                }
            
                targetButtons.on('change', function(){
                    targetQuestion.val($(this).val());
                
                    MDB.Forms.Index.checkTriggers(targetQuestion);
                    MDB.Forms.Index.formAnswersChanged(targetQuestion);
                });
            },
            checkOptionClick: function (option) {
                if(option.is(':checked')) {
                    option.addClass('serialize');
                } else {
                    option.removeClass('serialize');
                }
                MDB.Forms.Index.formAnswersChanged(option);
            },
            initExtraChoiceOptions: function(selector) {
                var newOptionTemplate = [
                    '<div class="dpo-row row">',
                    '    <div class="col-auto">',
                    '        <input name="extra-option" class="form-control" type="text">',
                    '    </div>',
                    '</div>'
                ].join('');

                var input = selector.next();
            
                input.unbind('click');
                input.click(function () {
                    var me = $(this);
                    var parent = me.parents().closest('.multiple-choice');

                    if(me.is(':checked')) {
                        if(!parent.find('[name="extra-option"]').length) {
                            me.addClass('serialize');
                            parent.append(newOptionTemplate);

                            var optionTxt = parent.find('[name="extra-option"]');
                            optionTxt.unbind('keyup');

                            optionTxt.keyup(function (e) {
                                if(e.keyCode === 13) {
                                    MDB.Forms.Index.appendChoiceToList(parent, optionTxt.val());
                                    optionTxt.val('');
                                }
                            });

                            optionTxt.blur(function (e) {
                                if(optionTxt.val() != '') {
                                    MDB.Forms.Index.appendChoiceToList(parent, optionTxt.val());
                                    optionTxt.val('');
                                }
                            });
                            optionTxt.focus();
                        }
                    } else {
                        me.removeClass('serialize');
                        parent.children().last().remove();
                    }
                
                });
            },
            appendChoiceToList: function (parent, value) {
                var valMsg = parent.siblings().first();

                if(value == ''){
                    valMsg.text('Fill something in please.');
                    valMsg.show();
                } else {
                    valMsg.text('');
                    valMsg.hide();

                    var rows = parent.find('[name="option-row"]')
                        ,maxColumns = rows.first().children().length
                        ,previousSibling = rows.last();

                    if(previousSibling.find('.check-option').length == 0) {
                        var temp = previousSibling.prev();
                        previousSibling.remove();
                        previousSibling = temp;
                    }

                    //var name = previousSibling.find('.question').prop('name');
                    var name = 'gen_' + MDB.Forms.Index.Guid();

                    var id = MDB.Forms.Index.Guid();
                    var innerTemplate = [
                        sprintf('<input type="hidden" name="answer" value="%s">', value),
                        sprintf('<input name="%s" class="check-option question multiple serialize" type="checkbox" id="%s-%s">', name, id, id),
                        sprintf(' <label for="%s-%s">%s</label>', id, id, value)
                    ].join('');

                    var column = previousSibling.children().first();

                    if(previousSibling.find('.check-option').length == maxColumns) {

                        var template = previousSibling.clone();
                        template.children().first().siblings().remove();
                        template.find('input').remove();
                        template.find('label').remove();
                        template.addClass('custom-check-option');
                        template.children().first().append(innerTemplate);

                        var input = template.find('input');
                        input.prop('checked', true);

                        input.click(function () {
                            MDB.Forms.Index.checkOptionClick(input);
                        });

                        template.insertAfter(previousSibling);
                    } else {
                        var container = rows.first().children().first().clone();
                        container.empty();
                        container.addClass('custom-check-option');
                        container.append(innerTemplate);
                        previousSibling.append(container);
                    
                        var input = previousSibling.find('input').last();
                        input.prop('checked', true);

                        input.click(function () {
                            MDB.Forms.Index.checkOptionClick(input);
                        });
                    }
                } 
            },
            getMatchedQuestionTriggers: function(option){
                var questionContainer = option.closest('.question-container'),
                    questionId = questionContainer.find('[name="question-id"]').val(),
                    isChoiceQuestion = questionContainer.is('.choice-question');

                var selectedAnswers = [];

                if(isChoiceQuestion){
                    questionContainer.find(':checked').each(function() {
                        selectedAnswers.push($(this).prev().val()); 
                    });
                    questionContainer.find('.question[type="hidden"]').each(function(){
                        selectedAnswers.push($(this).val()); 
                    });
                
                    if(option.is('button')){
                        selectedAnswers.push(option.val());
                    }
                } else{
                    questionContainer.find('.question[name="files"]').each(function(){
                        selectedAnswers.push($(this).text()); 
                    });
                    questionContainer.find('textarea.question').each(function(){
                        selectedAnswers.push($(this).val()); 
                    });

                    selectedAnswers = _.filter(selectedAnswers);
                }


                var triggered = _.filter(_triggers, { question: questionId });

                if (!triggered || triggered.length === 0 || !questionContainer.hasClass('active')) {
                    return [];
                }

                if(isChoiceQuestion){
                    return _.filter(triggered, function (trigger) {
                        return selectedAnswers.indexOf(trigger.key) !== -1; 
                    });
                }else{
                    if(selectedAnswers.length){
                        return triggered;
                    }

                    return [];
                }
            },
            checkPopupTriggers: function (question) {
                var triggered = _.filter(MDB.Forms.Index.getMatchedQuestionTriggers(question), function (trigger) {
                    return (trigger.popuptitle || trigger.popupbody);
                });

                MDB.Forms.Index.triggerPopups(triggered);
            },
            checkTriggers: function(option, event) {
                var questionContainer = option.closest('.question-container'),
                    questionId = questionContainer.find('[name="question-id"]').val(),
                    questionGroup = option.closest('.question-group'),
                    canBeCloned = questionGroup.hasClass('can-multiply'),
                    context = canBeCloned ? questionGroup : $(document);


                var triggered = _.filter(_triggers, { question: questionId });

                if (!triggered || triggered.length === 0) {
                    return;
                }

                var questionTriggers = _.filter(triggered, 'triggers');

                //Only show popups if the control was clicked by a human.
                var isHumanClickEvent =!!event && !!event.originalEvent && (event.target.checked === undefined || event.target.checked);
                var isFileUploadEvent=  !!event && !!event._isFileUpload;
            
                var allMatchedQuestionTriggers = MDB.Forms.Index.getMatchedQuestionTriggers(option);
            
                if (isHumanClickEvent || isFileUploadEvent) {
                    MDB.Forms.Index.triggerPopups(_.filter(allMatchedQuestionTriggers, function (trigger) {
                        return (trigger.popuptitle || trigger.popupbody); 
                    }));
                }

                var matchedQuestionTriggers = _.filter(allMatchedQuestionTriggers, 'triggers');
            
                //Nothing selected; disable all attached triggers
                if (!matchedQuestionTriggers.length && questionContainer.hasClass('active')) {
                    _.uniq(_.map(questionTriggers, 'triggers')).forEach(function (triggers) {
                        MDB.Forms.Index.triggerQuestion(triggers, false, context);
                    });
                }

                matchedQuestionTriggers.forEach(function (trigger) {
                    if (trigger.condition === 'none') {
                        MDB.Forms.Index.triggerQuestion(trigger.triggers, false, context);
                    } else if (trigger.condition === 'any') {
                        MDB.Forms.Index.triggerQuestion(trigger.triggers, true, context);
                    }
                });

                var nonSelectedTriggers = _.difference(
                    _.map(_.filter(questionTriggers, { condition: 'any' }), 'triggers'),
                    _.map(matchedQuestionTriggers, 'triggers')
                );

                nonSelectedTriggers = _.uniq(nonSelectedTriggers);

                //Only an active question should be allowed to disable other questions
                if (nonSelectedTriggers.length && questionContainer.hasClass('active')) {
                    nonSelectedTriggers.forEach(function (triggers) {
                        MDB.Forms.Index.triggerQuestion(triggers, false, context);
                    });
                }
            },
            triggerWaterfallQuestions: function (id, context) {
                var waterfallTriggers = []
                    , questionIdSelector = context.find('.question-group[data-id="' + id + '"] .question-container [name="question-id"]')
                    , questionIds = _.map(questionIdSelector, 'value');

                _triggers.forEach(function (trigger) {
                    if (questionIds.indexOf(trigger.question) !== -1) {
                        MDB.Forms.Index.triggerWaterfallQuestions(trigger.question, context);
                    }
                });

                waterfallTriggers = waterfallTriggers.concat(_.filter(_triggers, { question: id }));

                _.uniq(_.filter(waterfallTriggers, 'triggers')).forEach(function (waterfall) {
                    MDB.Forms.Index.triggerQuestion(waterfall.triggers, false, context);
                });
            },
            triggerPopups: function (triggers) {
                triggers.forEach(function (trigger) {
                    MDB.Forms.Index.showPopup(trigger.popuptitle, trigger.popupbody, trigger.popupsize, trigger.popupbutton, false);

                    var okBtn = $('#popup-ok-btn');
                    _popup.find('#popup-close-btn').hide();

                    var title = _popup.find('#popup-title');

                    title.css('font-weight', 'bold');
                    title.css('text-align', 'center');
                    _popup.find('#popupbody').css('text-align', 'center');

                    okBtn.unbind('click');
                    okBtn.click(function () {
                        MDB.Forms.Index.hidePopup();
                    });
                });
            },
            setCurrentPage: function (page, noPush) {
                var direction = page < _currentPage ? 'back' : 'forward'
                    , hasVisiblePages = $('.page-content:visible').length !== 0;

                var newPage = $('#page-content-' + page);
                if(_currentPage !== page && page <= _nrOfPages && page >= 0) {
                
                    if(page > 0 ) {
                        for(var i = 0; i < page; i++) {
                            if (!MDB.Forms.Index.pageComplete(i)) {
                                return MDB.Forms.Index.setCurrentPage(i);
                            }
                        }
                    }

                    $('#page-content-' + _currentPage).hide();
                    newPage.show();

                    //make sure that pre checked question triggers are fired.
                    newPage.find('.radio-option:checked').click();
                
                    _currentPage = page;
                    _invalidInputs = [];

                    if (!noPush) {
                        window.history.pushState(null, null, '#' + page);
                    }
                    MDB.Forms.Index.setButtonsState();

                    if(!MDB.Forms.Index.pageComplete(_currentPage)) {
                        window.scroll({
                            top: 0, 
                            left: 0, 
                            behavior: 'smooth' 
                        });
                    }
                }
                var firstvisibleInput = $('input').filter(':visible').first();

                if (!_boot && hasVisiblePages) {
                    if (firstvisibleInput.length == 0) {
                        if(direction == 'forward') {
                            if(_currentPage != _nrOfPages -1) {
                                MDB.Forms.Index.setCurrentPage(_currentPage+1, false);
                            }
                        } else if(direction == 'back') {
                            if(_currentPage != 0) {
                                MDB.Forms.Index.setCurrentPage(_currentPage-1, false);
                            }
                        }
                    } else {
                        firstvisibleInput.focus();
                    }  
                }
            
                _boot = false;

            },
            getCurrentPage: function () {
                return $('.page-content:visible:last').data('pageIndex') || 0;
            },
            getTotalPages: function () {
                return document.getElementsByClassName('page-content').length;
            },
            setButtonsState: function () {
                var pageComplete = MDB.Forms.Index.pageComplete();

                if (pageComplete) {
                    _intakeForwardBtn.removeClass('disabled');
                    _intakeForwardBtn.removeClass('hidden');
                } else {
                    _intakeForwardBtn.addClass('disabled');
                }

                //If first page
                if(_currentPage === 0){
                    _intakeBackBtn.addClass('disabled');
                    _intakeBackBtn.addClass('hidden');
                } else {
                    _intakeBackBtn.removeClass('disabled');
                    _intakeBackBtn.removeClass('hidden');
                }

                _intakeSaveBtn.removeClass('disabled');

                //If last page
                if (MDB.Forms.Index.isLastPage()) {
                    _intakeForwardBtn.addClass('disabled');
                    _intakeForwardBtn.addClass('hidden');

                    _intakeSaveBtn.html(_completeHtml);
                    _intakeSaveBtn.removeClass('btn-secondary');
                    _intakeSaveBtn.addClass('btn-primary');
                    _intakeSaveBtn.attr('data-dismiss', 'modal');

                    if (!MDB.Forms.Index.intakeCompleted()) {
                        _intakeSaveBtn.html(_saveHtml);
                        _intakeSaveBtn.attr('data-dismiss', '');
                    }
                } else {
                    _intakeSaveBtn.html(_saveIntermediateHtml);
                    _intakeSaveBtn.removeClass('btn-primary');
                    _intakeSaveBtn.addClass('btn-secondary');
                }
            },
            validatePage: function (page, ignoreErrorDisplay) {
                page = _.isNumber(page) ? page : MDB.Forms.Index.getCurrentPage();
                $('#page-content-' + page).find('.question-container').each(function () {
                    var container = $(this)
                        , isActive = container.is('.active');


                    if (container.is(':has(.multiple-choice)')) {
                        if (isActive) {
                            MDB.Forms.Index.validateMultipleChoice(container, ignoreErrorDisplay);
                        } else {
                            MDB.Forms.Index.processInput(container, []);
                        }
                    } else {
                        container.find('.question').each(function () {
                            if (isActive) {
                                MDB.Forms.Index.validateInput($(this), ignoreErrorDisplay);
                            } else {
                                MDB.Forms.Index.processInput($(this), []);
                            }
                        });
                    }
                });
            },
            validateMultipleChoice: function (item, ignoreErrorDisplay) {
                var container = item.is('.question-container') ? item : item.closest('.question-container');
                var multipleChoice = container.find('.multiple-choice');

                var errors = [];

                if (container.hasClass('active')) {
                    var isRequired = multipleChoice.has('.required:not([disabled])').length;
                    if (isRequired && !multipleChoice.has(':checked').length) {
                        errors.push(MDB.loadResourceString('Dpo_Intake_Input_Validation_Message_Text'));
                    }
                }

                MDB.Forms.Index.processInput(container, errors, ignoreErrorDisplay);
            },
            validateFileInput: function(input, ignoreErrorDisplay) {
                var value = input.text();

                //Called twice during file upload, once with an identifier-less element for some reason
                if (!input.prop('id')) {
                    return;
                }

                var errors = [];
                if (MDB.Forms.Index.isNullOrEmpty(value) && input.hasClass('required')) {
                    errors.push(MDB.loadResourceString('Dpo_Intake_Input_Validation_Message_Text'));
                }

                MDB.Forms.Index.processInput(input, errors, ignoreErrorDisplay);
            },
            validateInput: function (input, ignoreErrorDisplay) {
                if (input.hasClass('multiple') || input.is('.question-container:has(.multiple-choice)')) {
                    MDB.Forms.Index.validateMultipleChoice(input, ignoreErrorDisplay);
                    return;
                }

                if (input.hasClass('file-upload') || input.is('.question-container:has(.file-upload)')) {
                    MDB.Forms.Index.validateFileInput(input, ignoreErrorDisplay);
                    return;
                }

                var errors = [];

                var value = input.val();

                if (MDB.Forms.Index.isNullOrEmpty(value)) {
                    if (input.hasClass('required')) {
                        errors.push(MDB.loadResourceString('Dpo_Intake_Input_Validation_Message_Text'));
                    }
                } else {
                    if (_.includes(input.prop('name'), 'phone')) {
                        if (!MDB.Forms.Index.validPhone(value)) {
                            errors.push(MDB.loadResourceString('Dpo_Form_Validation_Phone_Text'));
                        }
                    }
                    if (_.includes(input.prop('name'), 'email')) {
                        if (!MDB.Forms.Index.validEmail(value)) {
                            errors.push(MDB.loadResourceString('Dpo_Form_Validation_Email_Text'));
                        }
                    }
                }
            
                MDB.Forms.Index.processInput(input, errors, ignoreErrorDisplay);
            },
            processInput: function (input, errors, ignoreErrorDisplay) {
                var msg = input.parent().find('.validation-msg');

                var targetId = input.prop('id');

                if (input.hasClass('question-container')) {
                    var questionId = input.find('[name="question-id"]').val();
                    targetId = input.closest('[data-id="' + questionId + '"]').prop('id');
                }

                var invalidPageInput = {
                    inputId: targetId,
                    page: input.closest('.page-content').data('page-index')
                };
            
                if (errors.length > 0) {
                    if (_.find(_invalidInputs, invalidPageInput) === undefined) {
                        _invalidInputs.push(invalidPageInput);
                    }

                    if (!ignoreErrorDisplay) {
                        msg.html(errors.join('<br />'));
                        msg.show();
                    }
                } else {
                    var invalidPageInputIndex = _.findIndex(_invalidInputs, invalidPageInput);

                    if (invalidPageInputIndex !== -1) {
                        _invalidInputs.splice(invalidPageInputIndex, 1);
                    }
                
                    msg.html('');
                    msg.hide();
                }
            },
            getAnswersId: function(){
                return _answersId;
            },
            saveForm: function(quietly) {
                var answers = MDB.Forms.Index.getAnswers();
                var completed = MDB.Forms.Index.intakeCompleted();
                var answersId = MDB.Forms.Index.getAnswersId();
            
                var request = {
                    FormId: $('#form-id').val(),
                    Id: answersId,
                    Answers: answers,
                    Completed: completed
                };

                return MDB.sendAjaxRequest(_config.saveFormUrl, request, 'POST').done(function(data) {

                    var lastPage = MDB.Forms.Index.isLastPage();
                    if (!quietly) {
                        data.response != null ? 
                            lastPage && completed ?
                            //completed
                                MDB.Notify.bootstrapSuccess(sprintf(MDB.loadResourceString('Dpo_Intake_Save_Success_Complete_Text'), _config.name)) :
                                lastPage ? 
                                //Intermediate save on last page
                                    MDB.Notify.bootstrapWarning(sprintf(MDB.loadResourceString('Dpo_Intake_Save_Success_Incomplete_Lastpage_Text'), _config.name, _config.name)) :
                                //Intermediate save
                                    MDB.Notify.bootstrapSuccess(sprintf(MDB.loadResourceString('Dpo_Intake_Save_Success_Incomplete_Text'), _config.name, _config.name)) : 
                        //Errors in the ajax response
                            MDB.Notify.bootstrapDanger(data.errors); 
                    }

                    //To make sure that when creating a new project and refreshing the page after a save, a new form will NOT be loaded.
                    if(window.location.href.indexOf('answersId') === -1) {
                        var pathAndQuery = window.location.href.split('?');
                        var newPathAndQuery;

                        if(pathAndQuery.length == 2) {
                            newPathAndQuery = '?' + pathAndQuery[1].split('#')[0] + '&answersId=' + answersId + '#' + _currentPage;
                        } else {
                            newPathAndQuery = '?answersId=' + answersId + '#' + _currentPage;
                        }

                        window.history.pushState(null, null, newPathAndQuery);
                    }

                    if (lastPage && !quietly && _redirectUrl != null) {
                        window.location.href = _redirectUrl;
                    }
                });
            },
            loadAnswers: function() {
                if(typeof _config.answers == 'string') {
                    _config.answers = JSON.parse(_config.answers);
                }

                var previousGroup;

                _config.answers = _config.answers == null ? [] : _config.answers;

                //loadMissingChoiceOptions requires groupings to at least be present
                _.filter(_config.answers, 'groupingid').forEach(function (group) {
                    var groupSelector = $('.question-group[data-id="' + group.id + '"]');

                    if (group.id == previousGroup) {
                        groupSelector = MDB.Forms.Index.cloneQuestionGroup(groupSelector.first());
                        groupSelector.find('.radio-option:checked').click();
                    }

                    if (group.groupingid) {
                    //Has to be set via attr to appear in DOM (and thus be useable as a DOM selector)
                        groupSelector.attr('data-grouping-id', group.groupingid);
                    }

                    previousGroup = group.id;
                });


                MDB.Forms.Index.loadMissingChoiceOptions();

                previousGroup = undefined;

                _config.answers.forEach(function (group) {
                    var groupSelector = $('.question-group[data-id="' + group.id + '"]');

                    if (group.groupingid) {
                        groupSelector = groupSelector.filter('[data-grouping-id="' + group.groupingid + '"]');
                    }

                    if (group.notapplicable) {
                        groupSelector.find('[name="not-applicable-chk"][data-target="group"]').click();
                    } else {
                        if (group.answers != null) {
                            group.answers.forEach(function (answer) {
                                var image = false;
                                var files = false;
                                var input;

                                if (answer.answer != null) {
                                    var question = groupSelector.find('[name="question-id"][value="' + answer.id + '"]').closest('.question-container').find('.question');

                                    // if(question.find('option').length > 0)
                                    //     console.warn(question);

                                    //Check if input is a image input (guid + extension) they have to be constructed differently because
                                    //of the way the fileupload control posts to the controller (name needs to be the same as the parameter in the action).
                                    if (answer.answer.indexOf(_image) === 0) {
                                        input = question;
                                        image = true;
                                    } else if (answer.answer.indexOf(_files) === 0) {
                                        input = question;
                                        files = true;
                                    } else {
                                        input = question.length !== 0 ? question : $('textarea[name="' + answer.id + '"]'); //Anoyingly, textArea's aren't inputs.
                                    }

                                    //load preview image for image inputs
                                    if (image) {
                                        input.parents('.upload-container').find('#image-preview')
                                            .html('<img src="' + _config.imagePreviewUrl + '?filename=' + encodeURIComponent(answer.answer.split(':')[1]) +
                                            '" class="preview-image"/>');

                                        input.text(answer.answer);
                                    } else if (files) {
                                        input.parents('.upload-container')
                                            .find('.files-uploaded')
                                            .load(_config.previewFilesUrl + '?filenames=' + encodeURIComponent(answer.answer.split(':')[1]), function () {
                                                MDB.Forms.Index.loadFileDeleteButtons(); 
                                            });

                                        input.text(answer.answer);
                                    } else {
                                        if (input.hasClass('multiple')) {

                                            input.each(function () {
                                                var me = $(this);

                                                if (me.prev().val() == answer.answer) {
                                                    if (me.hasClass('check-option')) {
                                                        if (!me.is(':checked')) {
                                                            me.click();
                                                        }
                                                    } else {
                                                        me.click();
                                                    }

                                                }
                                            });

                                        } else {
                                            if (input.hasClass('group')) {
                                            //console.log(answer.answer)
                                            // if (MDB.Forms.Index.isEmpty(input.val())) {

                                                var values = answer.answer.split(',');
                                                var nonEmptyValues = _.filter(values, function (v) {
                                                    return !MDB.Forms.Index.isEmpty(v); 
                                                });

                                                var isPipedAnswerCollection = _.reduce(nonEmptyValues, function (isPiped, v) {
                                                    return isPiped && v.indexOf('|') !== -1;
                                                }, true);

                                                if (isPipedAnswerCollection) {
                                                    nonEmptyValues.forEach(function (pipedValue) {
                                                        var valueParts = pipedValue.split('|');
                                                        //console.log(valueParts);
                                                        var name = valueParts[0];
                                                        var value = valueParts[1];

                                                        var control = _.find(input, { name: name });
                                                        if (control) {
                                                            control.value = value;
                                                        }
                                                    });
                                                }

                                                if (!isPipedAnswerCollection) {
                                                    input.each(function (i, control) {
                                                        var control = $(control);

                                                        if (!MDB.Forms.Index.isEmpty(values[i])) {
                                                            control.val(values[i]);
                                                        } else {
                                                            control.val('');
                                                        }
                                                    });
                                                }
                                            // }
                                            // else {
                                            //     console.log(answer.answer);
                                            // }
                                            } else {
                                                input.val(answer.answer);
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    }
                    previousGroup = group.id;
                });
            },
            getAnswers: function (id) {
                var regex = /[0-9A-Fa-f]{8}[-]?(?:[0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}/i
                    , singleQuestion = regex.test(id);

                if (singleQuestion) {
                    return MDB.Forms.Index.getAnswerFromQuestion(id);
                }

                if (_boot && _currentAnswers.length != 0 || !_changesMade && _currentAnswers.length != 0) {
                    return _currentAnswers;
                }
            
                var answerGroups = [];
                var implIds = {};

                $('.question-group').each(function () {
                    var group = $(this);
                
                    var na = group.find('[name="not-applicable-chk"][data-target="group"]');
                    var notApplicable = false;
                    if (na.length) {
                        notApplicable = na.is(':checked');
                    }

                    if (group.hasClass('can-multiply')) {
                        var questionId = group.data('id');
                        var groupingId = group.data('grouping-id');

                        if (!implIds[questionId]) {
                            implIds[questionId] = MDB.Forms.Index.Guid();
                        }

                        if (!groupingId) {
                            groupingId = MDB.Forms.Index.Guid();
                            group.attr('data-grouping-id', groupingId);
                        }

                        answerGroups.push({
                            Id: group.data('id'),
                            GroupingId: groupingId,
                            ImplId: implIds[questionId],
                            Answers: MDB.Forms.Index.getAnswersFromGroup(group),
                            NotApplicable: notApplicable
                        });
                    } else {
                        answerGroups.push({
                            Id: group.data('id'),
                            Answers: MDB.Forms.Index.getAnswersFromGroup(group),
                            NotApplicable: notApplicable
                        });
                    }
                });
                _changesMade = false;
                return answerGroups;
            },
            getAnswerFromQuestion: function (id) {
                var container = $('[name="question-id"][value="' + id + '"]').closest('.question-container');
                var multipleChoice = container.find('.multiple-choice');
                if (multipleChoice.length) {
                    return container.find('.serialize').next().text();
                }

                return container.find('.serialize').val();
            },
            getAnswersFromGroup: function(group){
                var answers = [];
            
                group.find('.question-container.active .serialize').each(function () {
                    var question = $(this)
                        , ignore = question.data('ignore');

                    if(!ignore) {
                        var container = question.parents().closest('.question-container')
                            , questionId = container.find('[name="question-id"]').val()
                            , questionVal = question.val()
                            , questionPrevVal = question.prev().val()
                            , questionText = question.text()
                            , questionType = question.prop('type')
                            , questionName = question.prop('name')
                            , questionInputId = question.prop('id')
                            , questionFieldInfo = {
                                Id: questionInputId,
                                Required: question.hasClass('required'),
                                Name: questionName,
                                Value: questionVal
                            };

                        if (questionType === 'checkbox' || questionType === 'radio') {
                            if (questionPrevVal != _moreOptions) {
                                answers.push({
                                    Id: questionId,
                                    Answer: questionPrevVal,
                                    Multiple: true
                                });
                            }
                        } else if (questionName === 'image') {
                            if (questionInputId.match('^q')) { 
                                answers.push({
                                    Id: questionId,
                                    Answer: questionText != '' && !questionText.match('^' + _image) ? 
                                        _image + questionText : questionText
                                });
                            }
                        } else if (questionName === 'files') {
                            if (questionInputId.match('^q')) {
                                answers.push({
                                    Id: questionId,
                                    Answer: questionText != '' && !questionText.match('^' + _files)  ? 
                                        _files + questionText : questionText
                                });
                            }
                        } else {
                            var val;
                            if (questionVal != '' && question.parents('[name=contact-container]').length != 0) {
                                val = questionName + '|' + questionVal;
                            } else {
                                val = questionVal;
                            }

                            if (val) {
                            //Remove comma's from answers, as they will break the json.
                                val = val.replace(/,/g, '');
                            }
                        

                            //Make sure initials end with a full stop
                            if (questionName == 'initials' && !MDB.Forms.Index.isNullOrEmpty(val) && !val.match('.$')) {
                                val += '.';
                            }

                            //Check if answer with same question id already exists
                            var sameId = answers.filter(function(a) {
                                if(a.Id === questionId) {
                                    return a;
                                }
                            });

                            //If more than one answer with the same Id exists we need to combine them.
                            if(sameId.length > 0) {
                                var existing = '';
                                var fields = _.reduce(_.map(sameId, 'Fields'), function (targetFields, currentFields) {
                                    if (currentFields) {
                                        currentFields.forEach(function (field) {
                                            if (targetFields.indexOf(field) === -1) {
                                                targetFields.push(field);
                                            }
                                        });
                                    }

                                    return targetFields;
                                }, [questionFieldInfo]);

                                sameId.forEach(function (answer) {
                                    if(!MDB.Forms.Index.isEmpty(answer.Answer)) {
                                        existing += answer.Answer + ',';
                                    }
                                    answers.splice(answers.indexOf(answer));
                                });

                                if(val != undefined) {
                                    existing += val;
                                }

                                answers.push({
                                    Fields: fields,

                                    Id: questionId,
                                    Answer: existing
                                });

                            } else {
                                answers.push({
                                    Fields: [questionFieldInfo],

                                    Id: questionId,
                                    Answer: val
                                });
                            }
                        }
                    }
                });
            
                group.find('[name="not-applicable-chk"][data-target="question"]:checked').each(function () {
                    var questionId = $(this).closest('.question-container').find('[name="question-id"]').val();

                    var currentAnswers = _.filter(answers, { Id: questionId });
                    if (!currentAnswers.length) {
                        answers.push({
                            Id: questionId,
                            NotApplicable: true,
                            Answer: ''
                        });
                    } else {
                        currentAnswers.forEach(function(answer) {
                            answer.NotApplicable = true;
                        });
                    }
                });

                return answers;
            },
            loadMissingChoiceOptions: function () {
            //bug: If there is only one answer selected and it's an answer that wasn't in the original
            //list of the form, the answer will be lost
                //            var groupAnswers = _.filter(_.flatMap(, 'answers'), { multiple: true });

                //            console.log(groupAnswers);
                //            console.log(_config.answers);

                if (_config.answers) {
                    var globalContext = $(document);

                    _config.answers.forEach(function(group) {
                        var multiAnswers = _.filter(group.answers, { multiple: true });
                        if (!multiAnswers.length) {
                            return;
                        }
                    
                        var context = group.groupingid ? globalContext.find('.question-group[data-grouping-id="' + group.groupingid + '"]') : globalContext;

                        multiAnswers.forEach(function(question) {
                            var row = context.find('[name="question-id"][value="' + question.id + '"]').closest('.question-row');

                            var input = row.find('input[value="' + question.answer + '"]').next();

                            if (!input.length) {
                                MDB.Forms.Index.appendChoiceToList(row, question.answer);
                            }
                        });
                    });
                }

                //            groupAnswers.forEach(function (group) {
                //                var questiongroup = $('[name="question-id"][value="' + group.id + '"]').parent();
                //
                //                var input = questiongroup.find('input[value="' + group.answer + '"]').next();
                //                if (!input.length) {
                //                    MDB.Forms.Index.appendChoiceToList(questiongroup, group.answer);
                //                }
                //            });
            },
            isLastPage: function(page) {
                page = _.isNumber(page) ? page : MDB.Forms.Index.getCurrentPage();

                if (page === _nrOfPages - 1) {
                    return true;
                }

                var nextQuestionContainingPage = $('[data-page-index="' + page + '"]').nextAll('[data-page-index]:has(.question-container.active)');
                return nextQuestionContainingPage.length === 0;
            },
            isLastPage: function(page) {
                page = _.isNumber(page) ? page : MDB.Forms.Index.getCurrentPage();

                if (page === _nrOfPages - 1) {
                    return true;
                }

                var nextQuestionContainingPage = $('[data-page-index="' + page + '"]').nextAll('[data-page-index]:has(.question-container.active)');
                return nextQuestionContainingPage.length === 0;
            },
            pageComplete: function (page) {
                page = _.isNumber(page) ? page : MDB.Forms.Index.getCurrentPage();
                MDB.Forms.Index.validatePage(page, true);

                return !_.filter(_invalidInputs, { page: page }).length;
            },
            intakeCompleted: function() {
                for(var i = 0 ; i < _nrOfPages; i++) {
                    if(!MDB.Forms.Index.pageComplete(i)) {
                        return false;
                    }
                }
                return true;
            },
            isNullOrEmpty: function (s) {
                return ( s === null || s === "" );
            },
            isEmpty: function(obj) {
                for(var key in obj) {
                    if(obj.hasOwnProperty(key)) {
                        return false;
                    }
                }
                return true;
            },
            searchLocalContact: function (name) {
                var def = $.Deferred();

                MDB.sendAjaxRequest(_config.searchLocalContacts, {name: name}).done(function (response) {
                    if(response.errors.length != 0) {
                        def.resolve(null);
                    } else {
                        var data = [];
                        if (response.data) {
                            data = _.isArray(response.data) ? response.data : [response.data];
                        }
                    
                        data.forEach(function (d) {
                            d.source = 'local'; 
                        });
                        def.resolve(data);
                    }
                });
                return def.promise();
            },
            prependKvKSearchToCompanyInputs: function () {
                $('[name="contact-container"]:has([name="companyname"]):not(:has(.open-search-company-btn))')
                    .prepend('<div class="col-8 offset-4"><button class="btn btn-secondary mb-2 btn-sm open-search-company-btn"><i class="fa fa-search"></i>Zoeken in handelsregister</button></div>');
            },
            getCompany: function (company, searchOwnContacts, parent) {
                var kvkProm = MDB.Forms.Index.getKvkData(company);
                var localContactsProm = $.Deferred(function(d) {
                    d.resolve([]); 
                });

                if (_config.searchLocalContacts != undefined && searchOwnContacts) {
                    localContactsProm = MDB.Forms.Index.searchLocalContact(company);
                }

                localContactsProm.done(function (localData) {
                    kvkProm.done(function (kvkData) {
                        var data = localData.concat(kvkData);

                        data.forEach(function (d) {
                            d.readField = function(field) {
                                return MDB.Forms.Index.readCompanyField(d, field); 
                            };
                        });

                        //Ensure every company name only appears once
                        data = _.uniqBy(_.filter(data), function (d) {
                            return _.map(_kvkData, function (f) {
                                return d.readField(f.system); 
                            }).join('');
                        });

                        if (data.length === 0) {
                            MDB.Notify.bootstrapWarning(MDB.loadResourceString('Dpo_Search_Contact_None_Found_Text'));
                        } else if (data.length === 1) {
                            MDB.Forms.Index.fillCompanyFields(data[0], parent, true);
                        } else {
                            MDB.Forms.Index.buildKvkPopup(data, parent);
                        }
                    });
                });
            },
            getKvkData: function (company) {
                var baseUrl = 'https://zoeken.kvk.nl/JsonSearch.ashx?q=';
                return $.Deferred(function(def) {
                    $.ajax({
                        url: baseUrl + company,
                        dataType: 'json',
                        success: function (json) {
                            var entries = _.filter(json.entries, { type: 'Hoofdvestiging' });

                            var results = _.chain(entries)
                                .sortBy('actief')
                                .sortBy('handelsnaam')
                                .value();

                            results.forEach(function (d) {
                                var nameParts = MDB.Forms.Index.getLegalFormFromCompanyName(d.handelsnaam);

                                if (nameParts.legal) {
                                    d.rechtsvorm = nameParts.legal.toUpperCase();
                                }

                                d.handelsnaam = nameParts.name;

                                d.land = 'Nederland';
                                d.source = 'kvk';
                            });

                            def.resolve(results);
                        }
                    });
                }).promise();
            },
            readCompanyField: function(company, systemField) {
                var fieldName = _.find(_kvkData, { 'system': systemField })[company.source];
                return company[fieldName] || '';
            },
            buildKvkPopup: function (companies, parent) {
                var templates = [];
            
                companies.forEach(function (company, i) {
                    templates.push([
                        '                <div class="col-6">',
                        '                    <div class="row">',
                        '                        <div class="col-12 company-panel">',
                        sprintf('                   <input class="pull-right" type="radio" name="company" value="%s" style="display:none"/>', i),
                        '                            <div class="panel panel-info">',
                        '                                <div class="panel-heading">',
                        company.readField('companyname') + ' ' + company.readField('companylegal'),
                        '                                </div>',
                        '                                <div class="panel-body">',
                        sprintf('                           %s %s <br />', company.readField('companystreet'), company.readField('companyhouseno') + company.readField('companyhousenoadd')), company.readField('companycity'),
                        '                                </div>',
                        '                           </div>',
                        '                       </div>',
                        '                    </div>',
                        '                </div>'
                    ].join(''));
                });

                var bodyHtml = '<div class="row">' + templates.join('') + '</div>';
            
                MDB.Forms.Index.showPopup('Er zijn meerdere resultaten', bodyHtml);

                var searchAgainButton = _popup.find('#popup-search-again-btn');

                searchAgainButton.unbind('click');
                searchAgainButton.show();
                searchAgainButton.on('click', function () {
                    parent.find('.open-search-company-btn').trigger('click');
                });

                var selectedCompany;
                var companyPanels = _popup.find('.company-panel');
                var panels = companyPanels.find('.panel');

                companyPanels.unbind('click');
                companyPanels.on('click', function() {
                    var me = $(this);

                    panels.removeClass('panel-success')
                        .addClass('panel-info');

                    companyPanels
                        .css('font-weight', 'normal');

                    me.find('.panel')
                        .removeClass('panel-info')
                        .addClass('panel-success');

                    me.css('font-weight', 'bold');

                    selectedCompany = me.find('[name="company"]').val();
                });

                $('#popup-ok-btn').unbind('click');
                $('#popup-ok-btn').click(function () {
                    MDB.Forms.Index.fillCompanyFields(companies[selectedCompany], parent);
                    MDB.Forms.Index.hidePopup();
                });
            },
            fillCompanyFields: function (company, parent) {
                var lastFilledInput; //Keep track of last filled in input

                _kvkData.forEach(function (field) {
                //fill in any input that matches a company field that is in the group.
                    var result = parent.find('[name="' + field.system + '"]');

                    if(result.length > 0) {
                        result.val(company.readField(field.system));
                        lastFilledInput = result;

                        result.trigger('blur');
                    }
                });

                if(company.source === 'local') {
                //Try to fill in other contacts on page, assumes primary and replacement contact.
                    var primaryContactPerson = company.Contacts ? company.Contacts.PrimaryContactPerson : {};
                    var replacementContactPerson = company.Contacts ? company.Contacts.ReplacementContactPerson : {};

                    [
                    //A space seems to be added at the end, causing the setter to fail
                        { control: parent.find('[name="prefix"]'), field: 'Prefix', modifier: _.trimEnd },
                        { control: parent.find('[name="initials"]'), field: 'Initials' },
                        { control: parent.find('[name="lastname"]'), field: 'Lastname' },
                        { control: parent.find('[name="email"]'), field: 'Email' },
                        { control: parent.find('[name="phone"]'), field: 'Phone' }
                    ].forEach(function (item) {
                        var primaryControl = item.control.eq(0);
                        var replacementControl = item.control.eq(1);

                        if (primaryControl.length && primaryContactPerson != null) {
                            var primaryFieldValue = primaryContactPerson[item.field];
                            if (item.modifier) {
                                primaryFieldValue = item.modifier(primaryFieldValue);
                            }

                            primaryControl.val(primaryFieldValue);
                            primaryControl.trigger('blur');
                            //                        MDB.Forms.Index.formAnswersChanged(primaryControl);
                        }

                        if (replacementControl.length && replacementContactPerson != null) {
                            var replacementFieldValue = replacementContactPerson[item.field];
                            if (item.modifier) {
                                replacementFieldValue = item.modifier(replacementFieldValue);
                            }

                            replacementControl.val(replacementFieldValue);
                            replacementControl.trigger('blur');
                            //                        MDB.Forms.Index.formAnswersChanged(replacementControl);
                        }
                    });
                }

                //Focus the next input after last filled in input by kvk
                var questions = $('.question');
                questions.each(function (i, value) {
                    var me = $(value);
                    if(me.prop('id') == lastFilledInput.prop('id')) {
                        questions.get(i+1).focus();
                    }
                });
                MDB.Forms.Index.checkOpenModals();
            },
            checkOpenModals: function () {
                var modals = $('.modal');

                modals.each(function () {

                    var modal = $(this);
                    if(modal.hasClass('show')) {
                        $('body').addClass('modal-open');
                    }
                });
            },
            getLegalFormFromCompanyName: function (name) {
                if (!name) {
                    return {
                        name: '',
                        legal: ''
                    };
                }

                var splitname = name.split(' ');
                var newName = '';
                var legalForm = '';

                splitname.forEach(function (part) {
                    if(_legalForms.indexOf(part.toLowerCase()) !== -1) {
                        var result = _legalForms.indexOf(part.toLowerCase());
                        legalForm = _legalForms[result];
                    } else {
                        newName += part + ' ';
                    }
                });

                newName = newName.trim();

                return {
                    name: newName, 
                    legal: legalForm
                };
            },
            showPopup: function (title, body, size, okButton, noControls) {
            //Set size of modal
                if(size != null) {
                    if(size === 'small') {
                        _popup.find('#popup-size').addClass('modal-sm');
                    } else if (size === "medium") {
                        _popup.find('#popup-size').addClass('modal-md');
                    } else if(size === 'large') {
                        _popup.find('#popup-size').addClass('modal-lg');
                    }
                } else {
                    _popup.find('#popup-size').removeClass('modal-sm');
                    _popup.find('#popup-size').removeClass('modal-md');
                    _popup.find('#popup-size').removeClass('modal-lg');
                }

                //Do we want control buttons at the bottom of the modal?
                if(noControls === true) {
                    _popup.find('#popup-controls').hide();
                } else {
                    _popup.find('#popup-controls').show();
                }

                //Only relevant for KvK search results
                _popup.find('#popup-search-again-btn').hide();
                _popup.find('#popup-close-btn').show();

                //Set title and body of popup
                _popup.find('#popup-title').html(title);
                _popup.find('#popup-body').html(body);

                if (okButton == null) {
                    if (_popup.data('default-ok-btn')) {
                        okButton = _popup.data('default-ok-btn');
                    }
                }

                //Set custom ok button if provided.
                if (okButton != null) {
                    if (!_popup.data('default-ok-btn')) {
                        _popup.data('default-ok-btn', _popup.find('#popup-ok-btn').html());
                    }

                    _popup.find('#popup-ok-btn').html(okButton);
                }

                //show modal and focus first input (if any)
                _popup.modal('show');
                _popup.find('input').first().focus();
            },
            hidePopup: function () {
                var body = _popup.find('#popup-body');
                body.empty();
                body.prop('style', '');
                _popup.find('#popup-title').prop('style', '');
                _popup.modal('hide');
            },
            triggerQuestion: function (id, show, context) {
                var questions = context.find('div [data-id=' + id + ']')
                    , questionContainer = questions.find('.question-container')
                    , isQuestionGroup = questions.is('.question-group')
                    , disableWaterfall = !questionContainer.is('.active');

                if(questions.length === 0) {
                    return;
                }

                if (show) {
                    questions.find('input:checked')
                        .addClass('serialize');

                    // if (isQuestionGroup) {
                    //     questionContainer.filter(':not(.inactive)').addClass('active');
                    // }
                    // else{
                    // }
                
                    questionContainer.addClass('active');
                    questionContainer.removeClass('inactive');
                    questions.show();
                } else {
                    questions.find('input:checked')
                        .removeClass('serialize');

                    // if (isQuestionGroup) {
                    //     questionContainer.filter(':not(.active)').addClass('inactive');
                    // }

                    questionContainer.removeClass('active');
                    questions.hide();
                }

                if (!show && !disableWaterfall) {
                    _.map(questions, 'dataset.id').forEach(function (id) {
                        MDB.Forms.Index.triggerWaterfallQuestions(id, context);
                    });
                } else if (show) {
                    if (!isQuestionGroup) {
                        questionContainer.each(function () {
                            MDB.Forms.Index.checkTriggers($(this).find('.question:first'), undefined);
                        });
                    } else {
                        questions.filter(':not(:first)').hide();
                    }
                }
            },
            loadFileDeleteButtons: function() {
                $('.delete-file-btn')
                    .unbind('click')
                    .on('click', function(e){
                        e.preventDefault();
                    
                        var btn = $(this);
    
                        var filename = btn.parent().find('#filename').val();
                        var fileInputs = btn.parents('.upload-container').find('input[name=files]');
    
                        var input;
    
                        //Kendo will add extra inputs when uploading files.
                        //We want the one that starts with q
                        fileInputs.each(function () {
                            var me = $(this);
                            if(me.prop('id').match('^q')) {
                                input = $(this);
                            }
                        });
    
                        MDB.sendAjaxRequest(_config.removeUrl, {filename: filename}).done(function (response) {
                            if(response.errors.length == 0){
                                if(response.data.length != 0) {
                                    input.text('files:' + response.data.join(','));
    
                                    btn.parents('.upload-container').find('.files-uploaded').load(_config.previewFilesUrl +
                                    '?filenames=' + encodeURIComponent(response.data.join(',')), function () {
                                        MDB.Forms.Index.loadFileDeleteButtons();
                                    });
                                } else {
                                    input.text('');
                                    btn.parents('.upload-container').find('.files-uploaded').empty();
                                }
                                MDB.Forms.Index.saveForm(true);
                                MDB.Forms.Index.checkTriggers(input);
                                MDB.Forms.Index.formAnswersChanged(fileInputs);
                            } else {
                                MDB.Notify.bootstrapDanger(data.errors.join(', '));
                            }
                        });
                    });
            },
            setCompanySearchButtons: function () {
                $('.open-search-company-btn').each(function() {
                    var me = $(this);
                    var parent = me.closest('.question-container');

                    me.unbind('click');
                    me.click(function () {
                        var prefillCompanyName = parent.find('[name="companyname"]').val();
                    
                        var searchOwnContactsButton = '';
                        if (_config.searchLocalContacts) {
                            searchOwnContactsButton = [
                                '   <div class="col-12 my-2">',
                                '       <label for="search-own-contacts" class="control-label">Zoek ook in eigen contacten</label>',
                                '       <input name="search-own-contacts" type="checkbox" checked id="search-own-contacts" />',
                                '   </div>'
                            ].join('');
                        }

                        MDB.Forms.Index.showPopup(
                            'Bedrijf zoeken', 
                            ['<div class="row form-group">',
                                '    <div class="col-12">',
                                '        <input name="search-company" type="text" id="search-company-txt" class="form-control" value=""/>',
                                '    </div>',
                                searchOwnContactsButton,
                                '    <div class="col-12">',
                                '        <button name="search-company" type="text" id="search-company-btn" class="btn btn-primary">',
                                '            <i class="fa fa-search"></i> Zoeken in handelsregister',
                                '        </button>',
                                '    </div>',
                                '</div>'
                            ].join(''), 'medium', null, true);
                    
                    
                        var searchButton = _popup.find('#search-company-btn');
                        var searchText = _popup.find('#search-company-txt');
                    
                        searchText.val(prefillCompanyName);
                    
                        searchButton.unbind('click');
                        searchButton.click(function (e) {
                            var company = searchText.val(),
                                searchOwnContacts = _popup.find('#search-own-contacts').is(':checked');

                            MDB.Forms.Index.hidePopup();
                            MDB.Forms.Index.getCompany(company, searchOwnContacts, parent);
                        });

                        searchText.unbind('keydown');
                        searchText.keydown(function (e) {
                            if(e.keyCode === 13) {
                                searchButton.click();
                            }
                        });

                    
                    });
                });
            },
            Guid: function () {
                return MDB.guid();
            },
            cloneQuestionGroup: function (questionGroup) {
                questionGroup.attr('name', 'cloned');
                var template = questionGroup.clone();
                template.prop('id', MDB.Forms.Index.Guid());

                template.find('.custom-check-option').remove();

                template.find('input,textarea,select').each(function () {
                    var me = $(this)
                        , newId = 'q-' + MDB.Forms.Index.Guid();

                    me.prop('disabled', null);

                    if (me.is(':checked')) {
                        me.removeClass('serialize');
                        me.prop('checked', false);
                    };

                    template.find('label[for="' + me.prop('id') + '"]').prop('for', newId);
                    me.prop('id', newId);
                });

                template.find(':not(input,textarea,select,.files-uploaded)[id]').each(function() {
                    $(this).prop('id', 'q-' + MDB.Forms.Index.Guid());
                });
            
                template.find('.multiple-choice').each(function () {
                    $(this).find('.radio-option').prop('name', 'gen_' + MDB.Forms.Index.Guid());
                });

                //If we are cloning file upload controls, best not include previously uploaded files
                template.find('.file-upload').text('');
                template.find('.files-uploaded').empty();
            
                //Clear all values but questionid/hidden/checkbox/radio values
                template.find('textarea,select,input:not([name="question-id"],[type="hidden"],[type="checkbox"],[type="radio"])').val('');
                template.attr('data-grouping-id', null);

                MDB.Forms.Index.initPopovers(template);
                return template.insertAfter(questionGroup);
            },
            loadMultiplyButtons: function () {
                $('[name="multiply-group-btn"]')
                    .unbind('click')
                    .bind('click', function () {
                        var questionGroupId = $(this).closest('.question-group').data('id')
                            , questionGroup = $('[data-id="' + questionGroupId + '"]:last');

                        if (!questionGroup.data('grouping-id')) {
                            questionGroup.attr('data-grouping-id', MDB.Forms.Index.Guid());
                        }

                        var newGroup = MDB.Forms.Index.cloneQuestionGroup(questionGroup);
                        newGroup.attr('data-grouping-id', MDB.Forms.Index.Guid());
                        newGroup.find('.radio-option:checked').click();

                        MDB.Forms.Index.initControls();

                        MDB.Forms.Index.setButtonsState();

                        MDB.Forms.Index.initMultipleChoice(newGroup);

                        MDB.Forms.Index.initButtons(newGroup);

                        MDB.Forms.Index.initFormAnswerChanged(newGroup.find('.question'));

                        MDB.Forms.Index.initNotApplicableCheckboxes();

                        $('[data-id="' + questionGroup.data('id') + '"]').hide();
                        newGroup.show();

                        questionGroup.hide();

                        var openModals = $('.modal.show');
                        if (openModals.length > 0) {
                            MDB.focusElement(openModals.first().find('.modal-header')[0]);
                        }
                    });
            },
            loadMultiplyNextButtons: function () {
                $('[name="multiple-next-btn"]').each(function () {
                    var me = $(this)
                        , questionGroup = me.closest('.question-group')
                        , questionGroupId = questionGroup.data('id')
                        , next = questionGroup.nextAll('[data-id="' + questionGroupId + '"]:first')
                        , hasNext = !!next.length;

                    me.prop('disabled', !hasNext);

                    me.unbind('click');
                    me.click(function () {
                        questionGroup.hide();
                        next.show();
                    });
                });
            },
            loadMultiplyPrevButtons: function () {
                $('[name="multiple-prev-btn"]').each(function () {
                    var me = $(this)
                        , questionGroup = me.closest('.question-group')
                        , questionGroupId = questionGroup.data('id')
                        , prev = questionGroup.prevAll('[data-id="' + questionGroupId + '"]:first')
                        , hasPrev = !!prev.length;

                    me.prop('disabled', !hasPrev);

                    me.unbind('click');
                    me.click(function () {
                        questionGroup.hide();
                        prev.show();
                    });
                });
            },
            loadMultiplyDeleteButtons: function () {
                $('[name="multiple-delete-btn"]')
                    .unbind('click')
                    .on('click', function() {
                        var me = $(this)
                            , questionGroup = me.closest('.question-group')
                            , questionGroupId = questionGroup.data('id')
                            , siblings = questionGroup.siblings('[data-id="' + questionGroupId + '"]');

                        questionGroup.find('[data-unique="true"]:checked')
                            .attr('checked', false)
                            .closest('.question')
                            .each(function(){
                                MDB.Forms.Index.enableUniqueOptions($(this)); 
                            });
                    
                        if (!siblings.length) {
                            questionGroup.find('textarea,select,input:not([name="question-id"],[type="hidden"],[type="checkbox"],[type="radio"])').val('');
                            questionGroup.find('input[type="checkbox"],input[type="radio"]').attr('checked', false);
                        } else {
                            var prevEl = questionGroup.prevAll('[data-id="' + questionGroupId + '"]:first')
                                , nextEl = questionGroup.nextAll('[data-id="' + questionGroupId + '"]:first');

                            questionGroup.remove();

                            //I'm not the first in the group
                            if (prevEl.length) {
                                prevEl.show();
                            } else {
                                nextEl.show();
                            }
                            MDB.Forms.Index.deleteGroupGeneratedAnswerSources(questionGroup);
                        }

                        MDB.Forms.Index.initMultiplyButtons();
                        MDB.Forms.Index.setButtonsState();
                    });
            },
            loadMultiplyLabels: function () {
                $('[name="multiple-count-txt"]').text(function() {
                    var me = $(this)
                        , questionGroup = me.closest('.question-group')
                        , questionGroupId = questionGroup.data('id')
                        , groups = questionGroup.parent().children('[data-id="' + questionGroupId + '"]');

                    var total = groups.length;
                    var current = groups.index(questionGroup) + 1;

                    //In case we only have the original, both should be 1
                    if (total === 0) {
                        total = 1;
                        current = 1;
                    }

                    return current + ' / ' + total;
                });
            },
            initMultiplyButtons: function () {
                MDB.Forms.Index.loadMultiplyButtons();
                MDB.Forms.Index.loadMultiplyNextButtons();
                MDB.Forms.Index.loadMultiplyPrevButtons();
                MDB.Forms.Index.loadMultiplyDeleteButtons();
                MDB.Forms.Index.loadMultiplyLabels();
            },
            initNotApplicableCheckboxes: function () {
                $('[name="not-applicable-chk"]')
                    .unbind('click')
                    .on('click', function() {
                        var me = $(this);

                        var target = me.data('target');
                        var targetsQuestion = target === 'question';
                        var checked = me.is(':checked');
                        var element;

                        if (targetsQuestion) {
                            var questionId = me.closest('.question-container')
                                .find('[name="question-id"]')
                                .val();

                            element = me.closest('[data-id="' + questionId + '"]');
                        } else {
                            element = me.parents().closest('.question-group');
                        }

                        if (checked) {
                            element.find('textarea').each(function () {
                                var input = $(this);
                                input.prop('disabled', true);
                                input.val('');
                            });

                            element.find('input[name!="not-applicable-chk"]').each(function () {
                                var input = $(this);
                                input.prop('disabled', true);

                                if (input.prop('type') === 'text' ||
                                input.prop('type') === 'email' ||
                                input.prop('type') === 'number' ||
                                input.prop('type') === 'password') {
                                    input.val('');
                                } else if (input.prop('type') === 'radio' ||
                                input.prop('type') === 'checkbox') {
                                    input.prop('checked', false);
                                }
                            });
                        } else {
                            element.find('input[name!="not-applicable-chk"]').each(function () {
                                var input = $(this);
                                input.prop('disabled', false);
                            });

                            element.find('textarea').each(function () {
                                var input = $(this);
                                input.prop('disabled', false);
                            });
                        }

                        if (targetsQuestion) {
                            var container = element.find('.question-container');

                            if (checked) {
                                container.find('.serialize').removeClass('serialize');
                            }


                            var firstQuestion = container.find('.question:first');
                            MDB.Forms.Index.checkTriggers(firstQuestion);

                            MDB.Forms.Index.formAnswersChanged(firstQuestion);
                        }
                    });
            },
            promptSendSecurityPolicy: function () {
                var toIdentifier = MDB.Forms.Index.Guid()
                    , textIdentifier = MDB.Forms.Index.Guid();

                var body =
                '<div class="form-group">' +
                    '<div class="row">' +
                        '<div class="col-3">' +
                            sprintf('<label for="%s">e-mailadressen \';\' gescheiden</label>', toIdentifier) +
                        '</div>' +
                        '<div class="col-9">' +
                            sprintf('<textarea id="%s" class="form-control" rows="5" name="to"></textarea>', toIdentifier) +
                        '</div>' +
                    '</div>' +
                '</div>' +
                '<div class="form-group">' +
                    '<div class="row">' +
                        '<div class="col-3">' +
                            sprintf('<label for="%s" class="control-label">Text</label>', textIdentifier) +
                        '</div>' +
                        '<div class="col-9">' +
                            sprintf('<textarea id="%s" class="form-control" rows="5" name="text"></textarea>', textIdentifier) +
                        '</div>' +
                    '</div>' +
                '</div>';

                var modal = MDB.modal({
                    buttons: [
                        '<button type="button" class="btn btn-default btn-ok" data-dismiss="modal">Versturen</button>',
                        '<button type="button" class="btn btn-default btn-close" data-dismiss="modal">Annuleren</button>'
                    ],
                    includeCloseByDefault: false,
                    shapeHtml: function (html) {
                        html.find('.modal-header').prepend('<div class="text-bold">Databeveiligingsbeleid mailen</div>');
                        html.find('.modal-body').html(body);
                    }
                });
            
                modal.find('.btn-ok').click(function () {
                    MDB.sendAjaxRequest(
                        '/DPO/Intake/MailSecurityPolicy',
                        {
                            to: modal.find('#' + toIdentifier).val(),
                            text: modal.find('#' + textIdentifier).val()
                        },
                        'POST'
                    ).done(function() {
                        MDB.Notify.bootstrapSuccess('Beleid verstuurd, het zal over enkele momenten aankomen');
                        MDB.killOpenModals();
                    });
                });
            },
            changeRedirectUrl: function (url) {
                _redirectUrl = url;
            },
            getRedirectUrl: function() {
                return _redirectUrl;
            },
            validEmail: function (email) {
                var regex = /.+\@.+\..+/i;
                var result = regex.exec(email);
                return result != null ? true : false;
            },
            validPhone: function (phone) {
                var regex = /^[(+]*[0-9\-\(\)\ ]{10,20}$/;
                var result = regex.exec(phone);
                return result != null ? true : false;
            }
        });
})();
